module.exports = __webpack_public_path__ + "static/media/bg15.5104a1a7.jpg";